import { getBoolVariation } from "./init";
export var enableNewCityPicker = function (defaultValue) {
    return getBoolVariation('city-picker-2.0', defaultValue);
};
export var getIfHiddenFields = function (defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    return getBoolVariation('cyxq-68436-filter-hidden-fields', defaultValue);
};
export var getIfFetchDataBySettingOfTableColumn = function () {
    return getBoolVariation('mfrd-3435-get-table-data-by-scene', false);
};
